import { useEffect } from 'react';

export default function useSubscription(events, eventName, handler) {
  useEffect(() => {
    events.on(eventName, handler);
  }, []);
}
